import BaseEntity from '../BaseEntity';
export default class LcovLine extends BaseEntity {
    constructor(data) {
        super();
        this.number = this.parseProperty(data, 'number');
        this.executionCount = this.parseProperty(data, 'executionCount');
    }
}
